import { SERVICE_MASTER_STATUS } from "@elixir/types";
import { Select } from "antd";
import {
  BanRegularIcon,
  CircleCheckRegularIcon,
  CircleRegularIcon,
  CircleXMarkRegularIcon,
} from "@elixir/icons";
import { useRef } from "react";

const ServiceStatusDropdownSelector = ({
  selectedStatus,
  onStatusChange,
}: {
  selectedStatus?: SERVICE_MASTER_STATUS;
  onStatusChange: (status: SERVICE_MASTER_STATUS) => void;
  showAllStatusOption?: boolean;
}) => {
  const statusOptions = [
    {
      key: SERVICE_MASTER_STATUS.ACTIVE,
      label: "Active",
      icon: CircleCheckRegularIcon,
      value: SERVICE_MASTER_STATUS.ACTIVE,
    },
    {
      key: SERVICE_MASTER_STATUS.INACTIVE,
      label: "Inactive",
      icon: BanRegularIcon,
      value: SERVICE_MASTER_STATUS.INACTIVE,
    },
  ];

  const handleChangeStatus = (status: SERVICE_MASTER_STATUS) => {
    onStatusChange?.(status);
  };

  const selectRef = useRef<any>(null);

  const onDropdownVisibleChange = () => {
    if (selectRef.current) {
      selectRef.current.blur();
    }
  };

  return (
    <>
      <Select
        key={selectedStatus}
        ref={selectRef}
        showSearch
        placeholder="Select status"
        optionFilterProp="children"
        value={selectedStatus}
        onChange={handleChangeStatus}
        filterOption={(input, option) => {
          const childrenText =
            option?.props?.children?.props?.children?.[1]?.props?.children ??
            "";
          const isMatch = childrenText
            .toLowerCase()
            .includes(input.toLowerCase());
          return isMatch;
        }}
        notFoundContent={null}
        dropdownStyle={{ minWidth: "fit-content" }}
        onDropdownVisibleChange={onDropdownVisibleChange}
        className="ant-selector-transparent dr-h-36 dr-flex dr-items-center dr-justify-between BodyRegular dr-px-12 dr-py-8 dr-rounded-8 dr-cursor-pointer dr-w-200 dr-max-w-200 dr-p-3"
      >
        {statusOptions.map((status) => (
          <Select.Option key={status.key} value={status.value}>
            <div className="dr-flex dr-items-center dr-space-x-8 BodyBody2Regular dr-py-6">
              <div className="dr-flex dr-items-center dr-space-x-8">
                <status.icon className="dr-min-w-16 dr-w-16 dr-h-16" />
                <div className="dr-capitalize">{status.label}</div>
              </div>
            </div>
          </Select.Option>
        ))}
      </Select>
    </>
  );
};

export default ServiceStatusDropdownSelector;
